import { initialState } from "./state"

export default {
  resetClient: state => {
    const init_state = initialState()
    init_state.location = state.location
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setAnswerSelected: (state, payload) => (state.answerSelected = payload),
  setName: (state, payload) => (state.name = payload),
  setContact: (state, payload) => (state.contact = payload),
  setCpf: (state, payload) => (state.cpf = payload),
  setExistReminder: (state, payload) => (state.existReminder = payload),
  setReminder: (state, payload) => (state.reminder = payload),
  setPostcode: (state, payload) => (state.postcode = payload),
  setStreet: (state, payload) => (state.street = payload),
  setNumber: (state, payload) => (state.number = payload),
  setComplement: (state, payload) => (state.complement = payload),
  setLocation: (state, payload) => (state.location = payload),
  setNote: (state, payload) => (state.note = payload),
  setReasonSelected: (state, payload) => (state.reasonSelected = payload),
  setIndicative: (state, payload) => (state.indicative = payload)
}
